import React from 'react';
import styled, { css } from 'styled-components';
import { PALETTE } from '~/assets/styles/base';

type ModalBodyWrapperProps = {
  $scrollable?: boolean;
  $border?: string;
};

const ModalBodyWrapper = styled.div<ModalBodyWrapperProps>`
  background: ${PALETTE.blue.main};
  padding: 20px 10px;
  max-height: 60vh;
  ${({ $scrollable }) =>
    $scrollable &&
    css`
      overflow-y: auto;
    `}
  border: ${(props) => props.$border || ''};
`;

const ContentWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  position: relative;
`;

type Props = {
  children?: React.ReactNode;
  scrollable?: boolean;
  border?: string;
};

const ModalBody: React.FC<Props> = ({ children, border, scrollable = true }): JSX.Element => (
  <ModalBodyWrapper $scrollable={scrollable} $border={border} data-testid="uiParts-modalBody">
    <ContentWrapper>{children}</ContentWrapper>
  </ModalBodyWrapper>
);

export default ModalBody;
